export class Param {
  employee_id: string;
  withEmployeeNo: boolean;
  showSvHierarchy: boolean;

}
